module.exports = __webpack_public_path__ + "img/footer-top.f28bade6.png";